import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Dashboard, Default } from "../../../../Constants/Constants";
import GoPremiumCard from "./GoPremiumCard/GoPremiumCard";
import Activities from "./Activities/Activities";
import TotalExpenditure from "./TotalExpenditure/TotalExpenditure";
import TopUsers from "./TopUsers/TopUsers";
import Earnings from "./Earnings/Earnings";
import TeamActivity from "./TeamActivity/TeamActivity";
import JobToday from "./JobToday/JobToday";
import OurTotalGrowth from "./OurTotalGrowth/OurTotalGrowth";
import RecentStatistics from "./RecentStatistics/RecentStatistics";
import Transaction from "./Transaction/Transaction";

const DefaultContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Default} parent={Dashboard} />
      <Container fluid className="dashboard_default">
        <Row className="widget-grid">
          <GoPremiumCard />
          <Activities />
          <TotalExpenditure />
          <TopUsers />
          <Earnings />
          <TeamActivity />
          <JobToday/>
          <OurTotalGrowth/>
          <RecentStatistics/>
          <Transaction/>
        </Row>
      </Container>
    </>
  );
};

export default DefaultContainer;
